/**
 * Checks whether the deployment is NC onprem/cloud
 * @returns {boolean} true if the deployment type is NC on prem
 */
export const isNcOnPremDeployment = () => {
    const { cloudDeployment, product } = window.productConfig || {};
    return product === 'NC' && cloudDeployment === false;
};
